import { useSelector } from "react-redux";

import OwnerCard from "./OwnerCard";
import InsuredCard from "./InsuredCard";
import {
  getAllOwnersFromParties,
  getAllInsuredsFromParties,
} from "js/utilities";

export default function OwnerAndInsuredCard({ data }) {
  const { user } = useSelector((state) => state.user);

  const owners = getAllOwnersFromParties(data.parties);

  const loggedInOwner = owners.find(
    (owner) => owner.person.taxId === user.identityNumber
  );

  const additionalOwners = owners.filter(
    (owner) => owner.person.taxId !== user.identityNumber
  );

  const insureds = getAllInsuredsFromParties(data.parties);

  return (
    <>
      <OwnerCard
        loggedInOwner={loggedInOwner}
        additionalOwners={additionalOwners}
      />

      <InsuredCard insureds={insureds} policy={data} />
    </>
  );
}
